<template>
  <div class="animated">
    <v-server-table
      v-if="collection"
      :columns="table_config.columns"
      :options="table_config.options"
      :ref="this.ref"
    >

      <div slot="beforeTable" class="pt-3">
        <b-row>
          <b-col>
            <b-input-group class="mt-0">
              <template v-slot:prepend>
                <b-input-group-text>
                  <i class="fal fa-hand-holding-seedling p-0 text-info"></i>
                </b-input-group-text>
              </template>
              <b-select
                v-model="selectedGrower"
                :options="growerOptions"
                @change="onGrowerSelect"
              >
                <template #first>
                  <b-form-select-option :value="null">All Growers</b-form-select-option>
                </template>
              </b-select>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group class="mt-0">
              <template v-slot:prepend>
                <b-input-group-text>
                  <i class="fal fa-box p-0 text-info"></i>
                </b-input-group-text>
              </template>
              <b-select
                v-model="selectedField"
                :options="fieldOptions"
                :disabled="!selectedGrower"
                @change="onFieldSelect"
              >
                <template #first>
                  <b-form-select-option :value="null">All Fields</b-form-select-option>
                </template>
              </b-select>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group class="mt-0">
              <template v-slot:prepend>
                <b-input-group-text>
                  <i class="fal fa-calendar p-0 text-info"></i>
                </b-input-group-text>
              </template>
              <b-form-datepicker 
                v-model="selectedDate"
                @input="onDateSelect"
              >
              </b-form-datepicker >
            </b-input-group>
          </b-col>
        </b-row>
      </div>

      <span slot="collected_at" slot-scope="{ row }">
        <router-link :to="`/results/${row.id}`" class="btn-link">
          {{ row.collected_at | moment("L") }}
        </router-link>
      </span>

      <span slot="report_number" slot-scope="{ row }">
        <router-link :to="`/results/${row.id}`" class="btn-link">
          {{ row.report_number }}
        </router-link>
      </span>

      <span slot="type" slot-scope="{ row }">
        {{ row.sample_type && row.sample_type.name }}
      </span>

    </v-server-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { ServerTable } from 'vue-tables-2'
import BaseServerTable from '@/components/shared/BaseServerTable'
import ResultCollection from '@/collections/result/ResultCollection'
import GrowerCollection from '@/collections/result/GrowerCollection'

Vue.use(ServerTable)

export default {
  name: 'ResultServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default () {
        return new ResultCollection()
      }
    },
    show_columns: {
      type: Array,
      default: () => [
        'report_number',
        'type',
        'test_package',
        'grower',
        'field',
        'collected_at'
      ]
    },
    filterable: {
      type: [Array, Boolean],
      default: () => true
    },
    sortable: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      table_config: _.merge(
        this.getDefaultTableConfig(), {
          options: {
            headings: {}
          }
        }
      ),
      customer_id: this.$store.getters.getAuthCustomerID,
      growers: new GrowerCollection(),
      selectedGrower: null,
      selectedField: null,
      selectedDate:null,
      growerOptions: [],
      fieldOptions: []
    }
  },
  mounted () {
    this.growers.fetch({ params: { customer_id: this.customer_id } }).then(() => {
      this.setupGrowerOptions()
    })
  },
  methods: {
    setupGrowerOptions () {
      this.growerOptions = this.growers.models.map(grower => ({
        value: grower.name,
        text: grower.name
      }))
    },

    onGrowerSelect (growerName) {
      this.selectedField = null
      this.fieldOptions = []

      // clear field filter
      this.setCustomFilter('result_field', '');

      if (growerName) {
        const selectedGrowerModel = this.growers.models.find(g => g.name === growerName)
        if (selectedGrowerModel && selectedGrowerModel.fields) {
          let fields = selectedGrowerModel.fields

          if (Array.isArray(fields)) {
            this.fieldOptions = fields.map(field => ({
              value: field,
              text: field
            }))
          }
        }

        // Apply grower filter
        this.setCustomFilter('result_grower', {
          field: 'grower',
          operator: 'eq',
          value: growerName,
          logic: 'and'
        })
      } else {
        // Clear grower filter
        this.setCustomFilter('result_grower', '')
      }
    },

    onFieldSelect (fieldName) {

      if (fieldName) {
        // Apply field filter
        this.setCustomFilter('result_field', {
          field: 'field',
          operator: 'eq',
          value: fieldName,
          logic: 'and'
        })
      } else {
        // Clear field filter
        this.setCustomFilter('result_field', '')
      }
    },

    onDateSelect (date) {
      if (date) {
        // Apply field filter
        this.setCustomFilter('result_date', {
          field: 'collected_at',
          operator: 'eq',
          value: date,
          logic: 'and'
        })
      } else {
        // Clear field filter
        this.setCustomFilter('result_date', '')
      }
    },

    prepareCollectionFilter (filter) {
      filter.sortAddDesc('received_at', true)
      filter.connectionAdd('sample_type')

      return filter
    },

    applyExtraFilterParams (data) {
      // cache filter
      let Filter = this.collection.getFilter();
      // search
      if (data.query) {
        Filter.search = data.query
      } else {
        Filter.search = null
      }
    },
  }
}
</script>
